/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */
import { onError } from 'apollo-link-error';
import _get from 'lodash/get';
import { ERROR_CODES } from '../components/common/ErrorHandler/messageActions';

export default onError(({ operation, graphQLErrors, networkError }) => {
  // To avoid imports/no-cycl error, importing as require on run-time.
  // eslint-disable-next-line global-require
  const updateLogs = require('../components/common/ErrorHandler/updateLogs')
    .default;

  let traceId = '';

  try {
    traceId = operation.getContext().response.headers.get('x-b3-traceid');
  } catch (err) {
    console.warn('Error in onError at traceid evaluation -> ', err);
  }

  if (graphQLErrors) {
    graphQLErrors.forEach(async ({ extensions, message, path }) => {
      console.log(
        `[GraphQL error]:\n Message: ${message},\n Path: ${path}${
          extensions.id ? `\n Id: ${extensions.id}` : ''
        }, ${traceId ? `\n TraceId: ${traceId}` : ''}`,
      );

      const status = _get(extensions, 'response.status');
      let errorCode = ERROR_CODES.GENERIC;

      if (status) {
        if (status === 401) errorCode = ERROR_CODES.AUTHORIZATION;

        const serverErrorCode = _get(extensions, 'response.body.errorCode');
        if (ERROR_CODES[serverErrorCode]) {
          errorCode = ERROR_CODES[serverErrorCode];
        }
      }
      await updateLogs(errorCode, traceId);
    });
  }
  if (networkError) {
    if (networkError.statusCode === 401) {
      updateLogs(ERROR_CODES.AUTHORIZATION, traceId);
    } else {
      updateLogs(ERROR_CODES.NETWORK, traceId);
    }
    console.log(`[Network error]: ${networkError}`);
  }
});
